var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotorcycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.711,
    height: 34.098,
    viewBox: "0 0 48.711 34.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "motorcycle",
    d: "M26.068,32a3.025,3.025,0,0,1,2.672,1.6l1.073,1.975,3.608-3.007A2.441,2.441,0,0,1,34.981,32h1.553a2.434,2.434,0,0,1,2.436,2.436v2.436a2.433,2.433,0,0,1-2.436,2.436h-4.7L36.024,47a12.336,12.336,0,0,1,2.946-.388,9.742,9.742,0,1,1-9.742,9.742,9.635,9.635,0,0,1,3.585-7.55L31.64,46.629a11.969,11.969,0,0,0-4.848,9.727,12.706,12.706,0,0,0,.244,2.436H21.677a12.582,12.582,0,0,0,.175-2.436A12.131,12.131,0,0,0,9.674,44.178H2.367V41.742A2.479,2.479,0,0,1,4.8,39.307H12.6a4.855,4.855,0,0,1,3.44,1.423l3.379,3.448,7.535-6.218L25.7,35.653h-4.46a1.827,1.827,0,1,1,0-3.653ZM34.1,56.356a4.871,4.871,0,1,0,4.871-4.871,4.208,4.208,0,0,0-.54.03l2.146,3.973a1.825,1.825,0,1,1-3.212,1.735L35.217,53.25A4.846,4.846,0,0,0,34.1,56.356ZM19.317,58.182a9.742,9.742,0,1,1,0-3.653H14.256a4.871,4.871,0,1,0,0,3.653ZM7.307,56.356a2.436,2.436,0,1,1,2.436,2.436A2.433,2.433,0,0,1,7.307,56.356Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.7aa33843bb3e42ac4ec7c170f1db3d62.svg";
export { ForwardRef as ReactComponent };